import { render, staticRenderFns } from "./dialog-error.vue?vue&type=template&id=0169d1cd&scoped=true"
import script from "./dialog-error.vue?vue&type=script&lang=js"
export * from "./dialog-error.vue?vue&type=script&lang=js"
import style0 from "./dialog-error.vue?vue&type=style&index=0&id=0169d1cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169d1cd",
  null
  
)

export default component.exports